import React from 'react';
import { VertCheckbox as AntCheckbox, CheckboxProps as AntCheckboxProps } from '@vertem-core/vertice-ds';

export interface VertCheckboxProps extends Omit<AntCheckboxProps, 'onChange'> {
  block?: boolean;
  template?: string;
  onChange?: (...args: any[]) => void;
}

const Checkbox: React.FC<VertCheckboxProps> = (props) => <AntCheckbox {...props} />;

export default Checkbox;
